export enum PaymentProviderEnum {
  IDEAL,
  PAYPAL,
  HOBEX
}
